import React, { useEffect, useState } from 'react';
import { getProjectsSimpleTableIndicator } from '../../../redux/actions/indicatorProjects';
import AcquisitionsMilestonesPendingTable from './Table/Table';
import './AcquisitionsMilestonesPending.scss';
import FiltersCardsProcess from './FiltersCardsProcess';
import { SelectFilters } from '../../Util/SelectFilters/SelectFilters';
import { handleLoading } from '../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useTable from '../../../hooks/useTable';
import FilterIndicators from '../../../models/FilterIndicators';
import { AppMenuTabs } from '../../MenuTabs/userTabsInterface';
import { setIndicatorResponse, setLoading } from '../../../redux/actions/dataTable';
import { translateMultipleText } from '../../../services/stringUtil';
import { emptyProjects } from '../../Portfolio/PortfolioUtil';
import { getNewFilteredIndicators } from '../../../api/indicatorApi';
import { parseFilterToApiCall } from '../../../services/util';
import { ProjectProductTypes } from '../../../models/ProjectProductTypes';
import { processIndicators } from '../../Portfolio/indicatorHelper';
import { arrayMove } from 'react-sortable-hoc';
import { addIndicators } from '../../../redux/actions/indicators';
import { setCurrentIndicator } from '../../../redux/actions/currentIndicator';
import Filter from '../../Portfolio/Filter/Filter';
import { resetIndicatorDetailFilter } from '../../../redux/actions/indicatorDetailFilters';
import { updateCreatingOrEditing } from '../../../redux/actions/menuTabs';
import ErrorMessageView from '../../Util/ErrorMessage/ErrorMessageView';

export const AcquisitionsMilestonesPending = () => {
  const [loadingData, setLoadingData] = useState(false);
  const { projects } = useTable();
  const [dataFilter, setDataFilter] = useState<any>(projects);
  const [filterOptionDate, setFilterOptionDate] = useState<any>();
  const [defaultValue, setDefaultValue] = useState<string>();
  const { currentIndicator } = useSelector<any, any>(state => state);
  const { projectTypeFilterOnDetail } = useSelector<any, any>(state => state.indicatorDetailFilter);

  const [btnFilterDataBoxs, setBtnFilterDataBoxs] = useState<any>([]);

  const dispatch = useDispatch();

  const { t } = useTranslation();

  // Filter
  const filterIndicators = useSelector<any, FilterIndicators>(state => state.filterIndicators);
  const stateProjectProductTypes = useSelector<any, FilterIndicators>(
    state => state.indicatorPayload.payload.projectProductTypes,
  );
  const menuTabs = useSelector<any, AppMenuTabs>(state => state.menuTabs);
  const portfolioSelectedTab = menuTabs.portfolioSelectedTab;
  const creatingOrEditing = menuTabs.creatingOrEditing;
  const [isLoading, setIsLoading] = useState(false);
  const [totalProjectsData, setTotalProjectsData] = useState(false);
  const [flag, setFlag] = useState<boolean>(false);
  const [hasError, setHasError] = useState(false);

  const projectTypeFilterChange = {
    ...filterIndicators,
    common: { ...filterIndicators.common, projectTypeFilters: stateProjectProductTypes },
    projectTypeFilters: stateProjectProductTypes,
  };

  const handleCommonFilterChange = async () => {
    dispatch(setLoading(true));
    setIsLoading(true);
    setHasError(false);

    try {
      const indicatorsToProcess = await getNewFilteredIndicators(
        {},
        { projectProductTypes: stateProjectProductTypes },
        {
          ...projectTypeFilterChange.common,
        },
      );
      dispatch(setIndicatorResponse(indicatorsToProcess));
      startProcessIndicators(
        indicatorsToProcess,
        translateMultipleText(` ${' '} ${portfolioSelectedTab.title}`, t),
        filterIndicators.common.projectTypeFilters,
      );
      setTotalProjectsData(emptyProjects(indicatorsToProcess.totalProjects));
    } catch (err) {
      console.error(err, 'Error fetching data from indicators');
      setHasError(true);
    } finally {
      dispatch(setLoading(false));
      setIsLoading(false);
    }
  };

  const startProcessIndicators = (inds, titleFromTab, projectTypeFilter = [ProjectProductTypes.Loan]) => {
    const result = processIndicators(inds, {
      titleFromTab,
      projectTypeFilter,
    });
    const elementSummary: any = result.find(elem => elem.id === 15);
    const indexSummary: number = result.indexOf(elementSummary);
    const sendEndSummary = arrayMove(result, indexSummary, result.length);

    dispatch(addIndicators(sendEndSummary));
    dispatch(
      setCurrentIndicator(
        sendEndSummary?.find(data => data.indicatorKey === 'ACQUISITION_WITH_MILESTONES_PENDING_TO_DATE'),
      ),
    );
    setIsLoading(false);
  };

  // const tabId0OrCreatingEditing = (menuTabs, creatingOrEditing) =>
  //   menuTabs.portfolioSelectedTab.tabId === 0 || creatingOrEditing;

  useEffect(() => {
    getFilteredSimpleIndicators(
      dispatch,
      currentIndicator.id,
      currentIndicator.indicatorKey,
      setLoadingData,
      projectTypeFilterChange,
      setHasError,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIndicator.id, dispatch, projectTypeFilterOnDetail, filterIndicators.common]);

  useEffect(() => {
    if (
      filterIndicators.common.coReponsibleDivisions.length > 0 ||
      filterIndicators.common.countryId.length > 0 ||
      filterIndicators.common.divisionId.length > 0 ||
      filterIndicators.common.interestIssues.length > 0 ||
      filterIndicators.common.participantDivisions.length > 0 ||
      filterIndicators.common.regionId.length > 0 ||
      filterIndicators.common.sectors.length > 0 ||
      filterIndicators.common.teamLeaders.length > 0
    )
      handleCommonFilterChange();
    setFlag(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterIndicators.common]);

  useEffect(() => {
    dispatch(resetIndicatorDetailFilter());
    if (
      !menuTabs.firstLoad &&
      // tabId0OrCreatingEditing(menuTabs, creatingOrEditing) &&
      filterIndicators.common.coReponsibleDivisions.length === 0 &&
      filterIndicators.common.countryId.length === 0 &&
      filterIndicators.common.divisionId.length === 0 &&
      filterIndicators.common.interestIssues.length === 0 &&
      filterIndicators.common.participantDivisions.length === 0 &&
      filterIndicators.common.regionId.length === 0 &&
      filterIndicators.common.sectors.length === 0 &&
      filterIndicators.common.teamLeaders.length === 0 &&
      flag
    ) {
      handleCommonFilterChange();
      setFlag(false);
      if (creatingOrEditing) {
        dispatch(updateCreatingOrEditing(false));
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterIndicators.common]);

  useEffect(() => {
    setDataFilter(projects);
  }, [projects]);

  const optionsFilter = [{ value: 'top100', optionLabel: 'new_top' }];

  return (
    <>
      <section className="acquisitions-milestones">
        {!hasError ? (
          <>
            <div className="filter-cards-process">
              <FiltersCardsProcess
                fndataFilter={setDataFilter}
                dataFilter={dataFilter}
                data={projects}
                filterOption={filterOptionDate}
                fnSetValue={setDefaultValue}
                defaultValue={defaultValue}
                fnSetBtnDataFilterPublic={setBtnFilterDataBoxs}
              />
            </div>
            <div className="head-select">
              <div className="filter-select">
                <SelectFilters
                  labelValue={t('new_youre_watching')}
                  options={optionsFilter}
                  handleChange={setDataFilter}
                  data={projects}
                  selectValue={defaultValue ? defaultValue : null}
                  fnSetValue={setDefaultValue}
                  btnDataFilterPublic={btnFilterDataBoxs}
                />
              </div>
            </div>
            <div>
              <AcquisitionsMilestonesPendingTable dataTable={dataFilter} />
            </div>
          </>
        ) : (
          <div className="error-message-style">
            <ErrorMessageView
              title={t('title_error_message_view')}
              description={t('desc_error_message_tab')}
              reload={handleCommonFilterChange}
              isIndicator={true}
            />
          </div>
        )}
      </section>
    </>
  );
};

const getFilteredSimpleIndicators = (
  d,
  currentIndicatorId,
  currentIndicatorKey,
  setLoading,
  projectTypeFilterChange?,
  setHasError?,
) => {
  try {
    setHasError?.(false);
    return handleLoading(
      () => d(getProjectsSimpleTableIndicator(currentIndicatorId, currentIndicatorKey, projectTypeFilterChange)),
      setLoading,
    );
  } catch (error) {
    console.error(error, 'Error fetching filtered simple indicators');
    setHasError?.(true);
  }
};
